import { Footer, Header, Person, Spacer300 } from 'components';
import _get from 'lodash.get';
import React, { PureComponent } from 'react';
import { HelmetDatoCms } from 'gatsby-source-datocms';
import styled from '@emotion/styled'
import { graphql } from 'gatsby'

export default class PersonTemplate extends PureComponent {
    constructor(props) {
        super(props);
        this.renderWrapper = this.renderWrapper.bind(this);
    }
    renderWrapper() {
        const { data } = this.props;

        return data ? (
            <PageWrapper
                {...{
                    textColor: _get(data, 'page.textColor.hex', ''),
                }}>
                <Header
                    {...{
                        ...this.props,
                        getTransitionContent: this.renderWrapper,
                    }}
                />
                <HelmetDatoCms
                    favicon={_get(data, 'site.faviconMetaTags', '')}
                />
                <Spacer300 />
                <Person {...data.page} />
                <Spacer300 />
                {/* <ContactBar {...data.contactBar} />
        <Spacer100 /> */}
                <Footer {...data.footer} />
            </PageWrapper>
        ) : (
                <div>.....</div>
            );
    }

    render() {
        return this.renderWrapper();
    }
}

const PageWrapper = styled.div`
    color: ${props => props.textColor};
`;

export const PersonTemplateQuery = graphql`
    query personTemplate($slug: String!) {
        site: datoCmsSite {
            ...DatoCmsSiteFragment
        }
        page: datoCmsPerson(slug: { eq: $slug }) {
            ...DatoCmsPersonFragment
        }
        contactBar: datoCmsContentsForContactBar {
            id
            firstAddress
            secondAddress
            links {
                id
                title
                url
            }
        }
        footer: datoCmsContentsForFooter {
            id
            heroText
            firstAddress
            secondAddress
            additionText
        }
        menu: datoCmsMenuItem {
            largeMenuItems {
                id
                slug
                name
                redirect
            }
            smallMenuItems {
                id
                slug
                name
                redirect
            }
        }
    }
`;
